import { connect } from '../../../../../react-redux';
import { createItem, createStimulus, setNextQuizEntry } from '../../../../../actions/modifications';
import { set } from '../../../../../actions/ui';
import { screenreaderNotification } from '../../../../../actions/alerts';
import AddContentBody from './presenter';
import { getInteractionTypes } from '../../../../../selectors/interactionTypes';
import { isEditingQuizEntry, getQuizEntryWithErrorsShowing } from '../../../../../selectors/quizzes';
var mapStateToProps = function mapStateToProps(state) {
  return {
    editingQuizEntry: isEditingQuizEntry(state),
    interactionTypes: getInteractionTypes(state),
    quizEntryWithErrorsShowing: getQuizEntryWithErrorsShowing(state)
  };
};
var mapDispatchToProps = {
  createItem: createItem,
  createStimulus: createStimulus,
  screenreaderNotification: screenreaderNotification,
  setNextQuizEntry: setNextQuizEntry,
  setUi: set
};
export default connect(mapStateToProps, mapDispatchToProps)(AddContentBody);